import { ConfettiIcon as PhosphorConfettiIcon } from "@phosphor-icons/react/dist/ssr/Confetti";

import { createAppIcon } from "@/components/createAppIcon";

export const CelebrationIcon = /* @__PURE__ */ createAppIcon(PhosphorConfettiIcon);
